(function() {
    'use strict';

    let DatiUtenteMitoCtrl = function(
        $q,
        $scope,
        $state,
        $stateParams,
        $cacheFactory,
        CONSTANTS,
        messaggiFctr,
        datiUtenteMitoService,
        gestioneUtenteService
    ) {
        this.gestioneUtenteService = gestioneUtenteService;
    };

    DatiUtenteMitoCtrl.$inject = [
        '$q',
        '$scope',
        '$state',
        '$stateParams',
        '$cacheFactory',
        'Mitom_CONSTANTS',
        'MitomMessaggiFctr',
        'MitomDatiUtenteMitoService',
        'MitomGestioneUtenteService'
    ];

    let TemplateUrl = function(CONSTANTS) {
        return (
            CONSTANTS.BASE_ROOT +
            CONSTANTS.COMPONENTS_PATH +
            'mitoman-gestione-utente/mitoman-dati-utente-mito/datiUtenteMito.component.html'
        );
    };
    TemplateUrl.$inject = ['Mitom_CONSTANTS'];

    let DatiUtenteMitoComponent = {
        controller: DatiUtenteMitoCtrl,
        controllerAs: 'datiUtenteMitoCtrl',
        templateUrl: TemplateUrl
    };

    angular
        .module('cbl.mitomanager.wa')
        .component('mitomdatiUtenteMito', DatiUtenteMitoComponent);
})();